package com.ustadmobile.core.util

actual fun parse8601Duration(duration: String): Long {
    TODO("parse8601Duration not implemented on javascript yet")
}